module.exports = __webpack_public_path__ + "img/cart.93ceb6c3.svg";